import styled from '../../../../../theme'

const Wrapper = styled.div`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 400;
  overflow: hidden;
`

export default Wrapper
